/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody,
  ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody,
  ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody,
  ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody,
  HTTPValidationError,
  ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams,
  ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams,
  ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams,
  OntologyGenerationRunResponse,
  OntologyGenerationSettingsResponse,
  OntologyGenerationSettingsUpdate,
  OntologySuggestionBatchApplyRequest,
  OntologySuggestionBatchApplyResponse,
  OntologySuggestionResponse,
  RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody,
  RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody,
  RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody,
  SemanticContextCompileResponse,
  SemanticContextMCPPolicyResponse,
  SemanticContextOntologyPayload,
  SemanticContextOverviewResponse,
  SemanticContextReadinessResponse,
  SemanticContextRuntimePackDetail,
  SemanticContextRuntimePackListResponse,
  SemanticContextSetupReadinessResponse,
  SemanticContextStructuredScopeResponse,
  SemanticContextStructuredScopeUpdate,
  StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams,
  WorkspaceSemanticCorrectionCreate,
  WorkspaceSemanticCorrectionListResponse,
  WorkspaceSemanticCorrectionResponse,
  WorkspaceSemanticCorrectionRoute,
  WorkspaceVerifiedQueryCreate,
  WorkspaceVerifiedQueryDraftRequest,
  WorkspaceVerifiedQueryListResponse,
  WorkspaceVerifiedQueryResponse,
  WorkspaceVerifiedQueryUpdate
} from '.././models';

import { customInstance } from '../../services/api-client';

/**
 * Get backend-derived readiness for the guided structured setup flow.
 * @summary Get guided workspace semantic setup readiness
 */
export const getSemanticContextSetupReadinessApiV1WorkspacesWorkspaceIdSemanticContextSetupReadinessGet = (
  workspaceId: number,
  signal?: AbortSignal,
) =>
  customInstance<SemanticContextSetupReadinessResponse>({
    url: `/api/v1/workspaces/${workspaceId}/semantic-context/setup-readiness`,
    method: 'GET',
    signal,
  });

/**
 * Run fixed read-only BigQuery checks and return the complete readiness projection.
 * @summary Run bounded workspace semantic readiness smoke
 */
export const runSemanticContextSetupReadinessSmokeApiV1WorkspacesWorkspaceIdSemanticContextSetupReadinessSmokePost = (
  workspaceId: number,
  signal?: AbortSignal,
) =>
  customInstance<SemanticContextSetupReadinessResponse>({
    url: `/api/v1/workspaces/${workspaceId}/semantic-context/setup-readiness/smoke`,
    method: 'POST',
    signal,
  });




/**
 * Get combined readiness, structured scope, and ontology state.
 * @summary Get workspace semantic context overview
 */
export const getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextOverviewResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context`, method: 'GET', signal
    },
      );
    }
  



export const getGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context`
    ] as const;
    }


export const getGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGetQueryOptions = <TData = Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>> = ({ signal }) => getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>>
export type GetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGetQueryError = HTTPValidationError


export function useGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet<TData = Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>,
          TError,
          Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet<TData = Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>,
          TError,
          Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet<TData = Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get workspace semantic context overview
 */

export function useGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet<TData = Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSemanticContextOverviewApiV1WorkspacesWorkspaceIdSemanticContextGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List reviewable semantic correction proposals for a workspace.
 * @summary List workspace semantic correction proposals
 */
export const listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet = (
    workspaceId: number,
    params?: ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceSemanticCorrectionListResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetQueryKey = (workspaceId?: number,
    params?: ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals`, ...(params ? [params]: [])
    ] as const;
    }


export const getListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetQueryOptions = <TData = Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError = HTTPValidationError>(workspaceId: number,
    params?: ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetQueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>> = ({ signal }) => listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet(workspaceId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>>
export type ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetQueryError = HTTPValidationError


export function useListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet<TData = Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params: undefined |  ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>,
          TError,
          Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet<TData = Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>,
          TError,
          Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet<TData = Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List workspace semantic correction proposals
 */

export function useListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet<TData = Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListCorrectionProposalsApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsGetQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a user-confirmed semantic correction proposal for steward review.
 * @summary Create a workspace semantic correction proposal
 */
export const createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost = (
    workspaceId: number,
    workspaceSemanticCorrectionCreate: WorkspaceSemanticCorrectionCreate,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceSemanticCorrectionResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceSemanticCorrectionCreate, signal
    },
      );
    }
  


export const getCreateCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost>>, TError,{workspaceId: number;data: WorkspaceSemanticCorrectionCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost>>, TError,{workspaceId: number;data: WorkspaceSemanticCorrectionCreate}, TContext> => {

const mutationKey = ['createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost>>, {workspaceId: number;data: WorkspaceSemanticCorrectionCreate}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost>>>
    export type CreateCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPostMutationBody = WorkspaceSemanticCorrectionCreate
    export type CreateCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPostMutationError = HTTPValidationError

    /**
 * @summary Create a workspace semantic correction proposal
 */
export const useCreateCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost>>, TError,{workspaceId: number;data: WorkspaceSemanticCorrectionCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPost>>,
        TError,
        {workspaceId: number;data: WorkspaceSemanticCorrectionCreate},
        TContext
      > => {

      const mutationOptions = getCreateCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Route a correction to workspace ontology, catalog review, or triage.
 * @summary Route a workspace semantic correction proposal
 */
export const routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost = (
    workspaceId: number,
    proposalId: number,
    workspaceSemanticCorrectionRoute: WorkspaceSemanticCorrectionRoute,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceSemanticCorrectionResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals/${proposalId}/route`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceSemanticCorrectionRoute, signal
    },
      );
    }
  


export const getRouteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost>>, TError,{workspaceId: number;proposalId: number;data: WorkspaceSemanticCorrectionRoute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost>>, TError,{workspaceId: number;proposalId: number;data: WorkspaceSemanticCorrectionRoute}, TContext> => {

const mutationKey = ['routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost>>, {workspaceId: number;proposalId: number;data: WorkspaceSemanticCorrectionRoute}> = (props) => {
          const {workspaceId,proposalId,data} = props ?? {};

          return  routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost(workspaceId,proposalId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RouteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePostMutationResult = NonNullable<Awaited<ReturnType<typeof routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost>>>
    export type RouteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePostMutationBody = WorkspaceSemanticCorrectionRoute
    export type RouteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePostMutationError = HTTPValidationError

    /**
 * @summary Route a workspace semantic correction proposal
 */
export const useRouteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost>>, TError,{workspaceId: number;proposalId: number;data: WorkspaceSemanticCorrectionRoute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof routeCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePost>>,
        TError,
        {workspaceId: number;proposalId: number;data: WorkspaceSemanticCorrectionRoute},
        TContext
      > => {

      const mutationOptions = getRouteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRoutePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a proposal from the workspace correction queue.
 * @summary Delete a workspace semantic correction proposal
 */
export const deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete = (
    workspaceId: number,
    proposalId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals/${proposalId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete>>, TError,{workspaceId: number;proposalId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete>>, TError,{workspaceId: number;proposalId: number}, TContext> => {

const mutationKey = ['deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete>>, {workspaceId: number;proposalId: number}> = (props) => {
          const {workspaceId,proposalId} = props ?? {};

          return  deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete(workspaceId,proposalId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete>>>
    
    export type DeleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete a workspace semantic correction proposal
 */
export const useDeleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete>>, TError,{workspaceId: number;proposalId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDelete>>,
        TError,
        {workspaceId: number;proposalId: number},
        TContext
      > => {

      const mutationOptions = getDeleteCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Approve a proposal and apply only the supported governed MVP action.
 * @summary Approve a workspace semantic correction proposal
 */
export const approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost = (
    workspaceId: number,
    proposalId: number,
    approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody: ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceSemanticCorrectionResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals/${proposalId}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody, signal
    },
      );
    }
  


export const getApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost>>, TError,{workspaceId: number;proposalId: number;data: ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost>>, TError,{workspaceId: number;proposalId: number;data: ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody}, TContext> => {

const mutationKey = ['approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost>>, {workspaceId: number;proposalId: number;data: ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody}> = (props) => {
          const {workspaceId,proposalId,data} = props ?? {};

          return  approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost(workspaceId,proposalId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostMutationResult = NonNullable<Awaited<ReturnType<typeof approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost>>>
    export type ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostMutationBody = ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody
    export type ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostMutationError = HTTPValidationError

    /**
 * @summary Approve a workspace semantic correction proposal
 */
export const useApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost>>, TError,{workspaceId: number;proposalId: number;data: ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePost>>,
        TError,
        {workspaceId: number;proposalId: number;data: ApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostBody},
        TContext
      > => {

      const mutationOptions = getApproveCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdApprovePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reject a proposal without mutating ontology or catalog state.
 * @summary Reject a workspace semantic correction proposal
 */
export const rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost = (
    workspaceId: number,
    proposalId: number,
    rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody: RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceSemanticCorrectionResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/correction-proposals/${proposalId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody, signal
    },
      );
    }
  


export const getRejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost>>, TError,{workspaceId: number;proposalId: number;data: RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost>>, TError,{workspaceId: number;proposalId: number;data: RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody}, TContext> => {

const mutationKey = ['rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost>>, {workspaceId: number;proposalId: number;data: RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody}> = (props) => {
          const {workspaceId,proposalId,data} = props ?? {};

          return  rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost(workspaceId,proposalId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostMutationResult = NonNullable<Awaited<ReturnType<typeof rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost>>>
    export type RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostMutationBody = RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody
    export type RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostMutationError = HTTPValidationError

    /**
 * @summary Reject a workspace semantic correction proposal
 */
export const useRejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost>>, TError,{workspaceId: number;proposalId: number;data: RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPost>>,
        TError,
        {workspaceId: number;proposalId: number;data: RejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostBody},
        TContext
      > => {

      const mutationOptions = getRejectCorrectionProposalApiV1WorkspacesWorkspaceIdSemanticContextCorrectionProposalsProposalIdRejectPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List workspace-owned verified query and RAG answer examples.
 * @summary List workspace verified query examples
 */
export const listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet = (
    workspaceId: number,
    params?: ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceVerifiedQueryListResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetQueryKey = (workspaceId?: number,
    params?: ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetQueryOptions = <TData = Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError = HTTPValidationError>(workspaceId: number,
    params?: ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetQueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>> = ({ signal }) => listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet(workspaceId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetQueryResult = NonNullable<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>>
export type ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetQueryError = HTTPValidationError


export function useListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet<TData = Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params: undefined |  ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>,
          TError,
          Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet<TData = Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>,
          TError,
          Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet<TData = Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List workspace verified query examples
 */

export function useListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet<TData = Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListVerifiedQueriesApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesGetQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a steward-authored verified query draft. It is not runtime-visible until pack activation.
 * @summary Create a workspace verified query example
 */
export const createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost = (
    workspaceId: number,
    workspaceVerifiedQueryCreate: WorkspaceVerifiedQueryCreate,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceVerifiedQueryResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceVerifiedQueryCreate, signal
    },
      );
    }
  


export const getCreateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost>>, TError,{workspaceId: number;data: WorkspaceVerifiedQueryCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost>>, TError,{workspaceId: number;data: WorkspaceVerifiedQueryCreate}, TContext> => {

const mutationKey = ['createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost>>, {workspaceId: number;data: WorkspaceVerifiedQueryCreate}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPostMutationResult = NonNullable<Awaited<ReturnType<typeof createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost>>>
    export type CreateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPostMutationBody = WorkspaceVerifiedQueryCreate
    export type CreateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPostMutationError = HTTPValidationError

    /**
 * @summary Create a workspace verified query example
 */
export const useCreateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost>>, TError,{workspaceId: number;data: WorkspaceVerifiedQueryCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPost>>,
        TError,
        {workspaceId: number;data: WorkspaceVerifiedQueryCreate},
        TContext
      > => {

      const mutationOptions = getCreateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create an AI draft for steward review without mutating active runtime behavior.
 * @summary Draft a verified query example with AI
 */
export const draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost = (
    workspaceId: number,
    workspaceVerifiedQueryDraftRequest: WorkspaceVerifiedQueryDraftRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceVerifiedQueryResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries/draft-with-ai`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceVerifiedQueryDraftRequest, signal
    },
      );
    }
  


export const getDraftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost>>, TError,{workspaceId: number;data: WorkspaceVerifiedQueryDraftRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost>>, TError,{workspaceId: number;data: WorkspaceVerifiedQueryDraftRequest}, TContext> => {

const mutationKey = ['draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost>>, {workspaceId: number;data: WorkspaceVerifiedQueryDraftRequest}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DraftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPostMutationResult = NonNullable<Awaited<ReturnType<typeof draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost>>>
    export type DraftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPostMutationBody = WorkspaceVerifiedQueryDraftRequest
    export type DraftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPostMutationError = HTTPValidationError

    /**
 * @summary Draft a verified query example with AI
 */
export const useDraftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost>>, TError,{workspaceId: number;data: WorkspaceVerifiedQueryDraftRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof draftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPost>>,
        TError,
        {workspaceId: number;data: WorkspaceVerifiedQueryDraftRequest},
        TContext
      > => {

      const mutationOptions = getDraftVerifiedQueryWithAiApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesDraftWithAiPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Edit a verified query draft or approved semantic asset.
 * @summary Update a workspace verified query example
 */
export const updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut = (
    workspaceId: number,
    queryId: number,
    workspaceVerifiedQueryUpdate: WorkspaceVerifiedQueryUpdate,
 ) => {
      
      
      return customInstance<WorkspaceVerifiedQueryResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries/${queryId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workspaceVerifiedQueryUpdate
    },
      );
    }
  


export const getUpdateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut>>, TError,{workspaceId: number;queryId: number;data: WorkspaceVerifiedQueryUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut>>, TError,{workspaceId: number;queryId: number;data: WorkspaceVerifiedQueryUpdate}, TContext> => {

const mutationKey = ['updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut>>, {workspaceId: number;queryId: number;data: WorkspaceVerifiedQueryUpdate}> = (props) => {
          const {workspaceId,queryId,data} = props ?? {};

          return  updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut(workspaceId,queryId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut>>>
    export type UpdateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPutMutationBody = WorkspaceVerifiedQueryUpdate
    export type UpdateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPutMutationError = HTTPValidationError

    /**
 * @summary Update a workspace verified query example
 */
export const useUpdateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut>>, TError,{workspaceId: number;queryId: number;data: WorkspaceVerifiedQueryUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPut>>,
        TError,
        {workspaceId: number;queryId: number;data: WorkspaceVerifiedQueryUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a verified query from the workspace authoring queue.
 * @summary Delete a workspace verified query example
 */
export const deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete = (
    workspaceId: number,
    queryId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries/${queryId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete>>, TError,{workspaceId: number;queryId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete>>, TError,{workspaceId: number;queryId: number}, TContext> => {

const mutationKey = ['deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete>>, {workspaceId: number;queryId: number}> = (props) => {
          const {workspaceId,queryId} = props ?? {};

          return  deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete(workspaceId,queryId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete>>>
    
    export type DeleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete a workspace verified query example
 */
export const useDeleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete>>, TError,{workspaceId: number;queryId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDelete>>,
        TError,
        {workspaceId: number;queryId: number},
        TContext
      > => {

      const mutationOptions = getDeleteVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Approve a verified query for the next Runtime Context Pack compile.
 * @summary Approve a workspace verified query example
 */
export const approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost = (
    workspaceId: number,
    queryId: number,
    approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody: ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceVerifiedQueryResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries/${queryId}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody, signal
    },
      );
    }
  


export const getApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost>>, TError,{workspaceId: number;queryId: number;data: ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost>>, TError,{workspaceId: number;queryId: number;data: ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody}, TContext> => {

const mutationKey = ['approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost>>, {workspaceId: number;queryId: number;data: ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody}> = (props) => {
          const {workspaceId,queryId,data} = props ?? {};

          return  approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost(workspaceId,queryId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostMutationResult = NonNullable<Awaited<ReturnType<typeof approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost>>>
    export type ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostMutationBody = ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody
    export type ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostMutationError = HTTPValidationError

    /**
 * @summary Approve a workspace verified query example
 */
export const useApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost>>, TError,{workspaceId: number;queryId: number;data: ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePost>>,
        TError,
        {workspaceId: number;queryId: number;data: ApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostBody},
        TContext
      > => {

      const mutationOptions = getApproveVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdApprovePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reject a verified query draft so it cannot compile into runtime packs.
 * @summary Reject a workspace verified query example
 */
export const rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost = (
    workspaceId: number,
    queryId: number,
    rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody: RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceVerifiedQueryResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/verified-queries/${queryId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody, signal
    },
      );
    }
  


export const getRejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost>>, TError,{workspaceId: number;queryId: number;data: RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost>>, TError,{workspaceId: number;queryId: number;data: RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody}, TContext> => {

const mutationKey = ['rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost>>, {workspaceId: number;queryId: number;data: RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody}> = (props) => {
          const {workspaceId,queryId,data} = props ?? {};

          return  rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost(workspaceId,queryId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostMutationResult = NonNullable<Awaited<ReturnType<typeof rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost>>>
    export type RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostMutationBody = RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody
    export type RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostMutationError = HTTPValidationError

    /**
 * @summary Reject a workspace verified query example
 */
export const useRejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost>>, TError,{workspaceId: number;queryId: number;data: RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPost>>,
        TError,
        {workspaceId: number;queryId: number;data: RejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostBody},
        TContext
      > => {

      const mutationOptions = getRejectVerifiedQueryApiV1WorkspacesWorkspaceIdSemanticContextVerifiedQueriesQueryIdRejectPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Return tenant policy, workspace opt-in, tool exposure, and OAuth metadata.
 * @summary Get effective workspace MCP policy
 */
export const getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextMCPPolicyResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/mcp-policy`, method: 'GET', signal
    },
      );
    }
  



export const getGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/mcp-policy`
    ] as const;
    }

    
export const getGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGetQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>> = ({ signal }) => getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>>
export type GetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGetQueryError = HTTPValidationError


export function useGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet<TData = Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet<TData = Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet<TData = Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get effective workspace MCP policy
 */

export function useGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet<TData = Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWorkspaceMcpPolicyApiV1WorkspacesWorkspaceIdSemanticContextMcpPolicyGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get readiness derived from connector, scope, ontology, and active pack state.
 * @summary Get workspace semantic context readiness
 */
export const getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextReadinessResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/readiness`, method: 'GET', signal
    },
      );
    }
  



export const getGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/readiness`
    ] as const;
    }

    
export const getGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGetQueryOptions = <TData = Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>> = ({ signal }) => getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>>
export type GetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGetQueryError = HTTPValidationError


export function useGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet<TData = Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>,
          TError,
          Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet<TData = Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>,
          TError,
          Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet<TData = Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get workspace semantic context readiness
 */

export function useGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet<TData = Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSemanticContextReadinessApiV1WorkspacesWorkspaceIdSemanticContextReadinessGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get selected warehouse connector and scoped tables for this workspace.
 * @summary Get workspace structured warehouse scope
 */
export const getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextStructuredScopeResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/structured-scope`, method: 'GET', signal
    },
      );
    }
  



export const getGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/structured-scope`
    ] as const;
    }

    
export const getGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGetQueryOptions = <TData = Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>> = ({ signal }) => getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>>
export type GetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGetQueryError = HTTPValidationError


export function useGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet<TData = Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>,
          TError,
          Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet<TData = Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>,
          TError,
          Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet<TData = Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get workspace structured warehouse scope
 */

export function useGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet<TData = Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopeGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update selected warehouse connector and scoped tables for this workspace.
 * @summary Update workspace structured warehouse scope
 */
export const updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost = (
    workspaceId: number,
    semanticContextStructuredScopeUpdate: SemanticContextStructuredScopeUpdate,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextStructuredScopeResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/structured-scope`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: semanticContextStructuredScopeUpdate, signal
    },
      );
    }
  


export const getUpdateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost>>, TError,{workspaceId: number;data: SemanticContextStructuredScopeUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost>>, TError,{workspaceId: number;data: SemanticContextStructuredScopeUpdate}, TContext> => {

const mutationKey = ['updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost>>, {workspaceId: number;data: SemanticContextStructuredScopeUpdate}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePostMutationResult = NonNullable<Awaited<ReturnType<typeof updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost>>>
    export type UpdateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePostMutationBody = SemanticContextStructuredScopeUpdate
    export type UpdateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePostMutationError = HTTPValidationError

    /**
 * @summary Update workspace structured warehouse scope
 */
export const useUpdateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost>>, TError,{workspaceId: number;data: SemanticContextStructuredScopeUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePost>>,
        TError,
        {workspaceId: number;data: SemanticContextStructuredScopeUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateStructuredScopeApiV1WorkspacesWorkspaceIdSemanticContextStructuredScopePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get ontology rows for this workspace.
 * @summary Get workspace ontology
 */
export const getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextOntologyPayload>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology`, method: 'GET', signal
    },
      );
    }
  



export const getGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/ontology`
    ] as const;
    }

    
export const getGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGetQueryOptions = <TData = Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>> = ({ signal }) => getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>>
export type GetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGetQueryError = HTTPValidationError


export function useGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet<TData = Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>,
          TError,
          Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet<TData = Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>,
          TError,
          Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet<TData = Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get workspace ontology
 */

export function useGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet<TData = Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOntologyApiV1WorkspacesWorkspaceIdSemanticContextOntologyGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Replace the MVP ontology draft rows for this workspace.
 * @summary Replace workspace ontology draft
 */
export const replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut = (
    workspaceId: number,
    semanticContextOntologyPayload: SemanticContextOntologyPayload,
 ) => {
      
      
      return customInstance<SemanticContextOntologyPayload>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology/draft`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: semanticContextOntologyPayload
    },
      );
    }
  


export const getReplaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut>>, TError,{workspaceId: number;data: SemanticContextOntologyPayload}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut>>, TError,{workspaceId: number;data: SemanticContextOntologyPayload}, TContext> => {

const mutationKey = ['replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut>>, {workspaceId: number;data: SemanticContextOntologyPayload}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPutMutationResult = NonNullable<Awaited<ReturnType<typeof replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut>>>
    export type ReplaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPutMutationBody = SemanticContextOntologyPayload
    export type ReplaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPutMutationError = HTTPValidationError

    /**
 * @summary Replace workspace ontology draft
 */
export const useReplaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut>>, TError,{workspaceId: number;data: SemanticContextOntologyPayload}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPut>>,
        TError,
        {workspaceId: number;data: SemanticContextOntologyPayload},
        TContext
      > => {

      const mutationOptions = getReplaceOntologyDraftApiV1WorkspacesWorkspaceIdSemanticContextOntologyDraftPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get tenant capability policy and model options for workspace ontology auto-build.
 * @summary Get ontology auto-build settings
 */
export const getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OntologyGenerationSettingsResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/settings`, method: 'GET', signal
    },
      );
    }
  



export const getGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/settings`
    ] as const;
    }

    
export const getGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGetQueryOptions = <TData = Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>> = ({ signal }) => getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>>
export type GetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGetQueryError = HTTPValidationError


export function useGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet<TData = Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet<TData = Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet<TData = Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get ontology auto-build settings
 */

export function useGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet<TData = Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update tenant capability policy for governed ontology auto-build.
 * @summary Update ontology auto-build settings
 */
export const updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut = (
    workspaceId: number,
    ontologyGenerationSettingsUpdate: OntologyGenerationSettingsUpdate,
 ) => {
      
      
      return customInstance<OntologyGenerationSettingsResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: ontologyGenerationSettingsUpdate
    },
      );
    }
  


export const getUpdateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut>>, TError,{workspaceId: number;data: OntologyGenerationSettingsUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut>>, TError,{workspaceId: number;data: OntologyGenerationSettingsUpdate}, TContext> => {

const mutationKey = ['updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut>>, {workspaceId: number;data: OntologyGenerationSettingsUpdate}> = (props) => {
          const {workspaceId,data} = props ?? {};

          return  updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut(workspaceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut>>>
    export type UpdateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPutMutationBody = OntologyGenerationSettingsUpdate
    export type UpdateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPutMutationError = HTTPValidationError

    /**
 * @summary Update ontology auto-build settings
 */
export const useUpdateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut>>, TError,{workspaceId: number;data: OntologyGenerationSettingsUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPut>>,
        TError,
        {workspaceId: number;data: OntologyGenerationSettingsUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateOntologyGenerationSettingsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSettingsPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create pending ontology suggestions. This does not mutate ontology rows or active packs.
 * @summary Draft ontology suggestions with AI
 */
export const createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OntologyGenerationRunResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/runs`, method: 'POST', signal
    },
      );
    }
  


export const getCreateOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost>>, TError,{workspaceId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost>>, TError,{workspaceId: number}, TContext> => {

const mutationKey = ['createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost>>, {workspaceId: number}> = (props) => {
          const {workspaceId} = props ?? {};

          return  createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost(workspaceId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost>>>
    
    export type CreateOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPostMutationError = HTTPValidationError

    /**
 * @summary Draft ontology suggestions with AI
 */
export const useCreateOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost>>, TError,{workspaceId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPost>>,
        TError,
        {workspaceId: number},
        TContext
      > => {

      const mutationOptions = getCreateOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List ontology auto-build generation runs for this workspace.
 * @summary List ontology auto-build runs
 */
export const listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OntologyGenerationRunResponse[]>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/runs`, method: 'GET', signal
    },
      );
    }
  



export const getListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/runs`
    ] as const;
    }

    
export const getListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGetQueryOptions = <TData = Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>> = ({ signal }) => listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>>
export type ListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGetQueryError = HTTPValidationError


export function useListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>,
          TError,
          Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>,
          TError,
          Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List ontology auto-build runs
 */

export function useListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListOntologyGenerationRunsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Stream live ontology generation progress via Server-Sent Events (SSE).
 * @summary Stream ontology generation run events
 */
export const streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet = (
    workspaceId: number,
    runId: number,
    params: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/runs/${runId}/stream`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetQueryKey = (workspaceId?: number,
    runId?: number,
    params?: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/runs/${runId}/stream`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetQueryOptions = <TData = Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError = HTTPValidationError>(workspaceId: number,
    runId: number,
    params: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetQueryKey(workspaceId,runId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>> = ({ signal }) => streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet(workspaceId,runId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && runId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetQueryResult = NonNullable<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>>
export type StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetQueryError = HTTPValidationError


export function useStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet<TData = Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    runId: number,
    params: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>,
          TError,
          Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet<TData = Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    runId: number,
    params: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>,
          TError,
          Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet<TData = Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    runId: number,
    params: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Stream ontology generation run events
 */

export function useStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet<TData = Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    runId: number,
    params: StreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof streamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getStreamOntologyGenerationRunApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdStreamGetQueryOptions(workspaceId,runId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List reviewable ontology suggestions, optionally filtered by status.
 * @summary List ontology auto-build suggestions
 */
export const listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet = (
    workspaceId: number,
    params?: ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OntologySuggestionResponse[]>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/suggestions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetQueryKey = (workspaceId?: number,
    params?: ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/suggestions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetQueryOptions = <TData = Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError = HTTPValidationError>(workspaceId: number,
    params?: ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetQueryKey(workspaceId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>> = ({ signal }) => listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet(workspaceId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>>
export type ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetQueryError = HTTPValidationError


export function useListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params: undefined |  ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>,
          TError,
          Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>,
          TError,
          Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List ontology auto-build suggestions
 */

export function useListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet<TData = Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    params?: ListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListOntologyGenerationSuggestionsApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsGetQueryOptions(workspaceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Preflight and apply a review set in dependency order and one transaction.
 * @summary Atomically apply ontology suggestions from one generation run
 */
export const applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost = (
    workspaceId: number,
    runId: number,
    ontologySuggestionBatchApplyRequest: OntologySuggestionBatchApplyRequest,
 signal?: AbortSignal
) => {


      return customInstance<OntologySuggestionBatchApplyResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/runs/${runId}/suggestions/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ontologySuggestionBatchApplyRequest, signal
    },
      );
    }



export const getApplyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost>>, TError,{workspaceId: number;runId: number;data: OntologySuggestionBatchApplyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost>>, TError,{workspaceId: number;runId: number;data: OntologySuggestionBatchApplyRequest}, TContext> => {

const mutationKey = ['applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost>>, {workspaceId: number;runId: number;data: OntologySuggestionBatchApplyRequest}> = (props) => {
          const {workspaceId,runId,data} = props ?? {};

          return  applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost(workspaceId,runId,data,)
        }




  return  { mutationFn, ...mutationOptions }}

    export type ApplyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPostMutationResult = NonNullable<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost>>>
    export type ApplyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPostMutationBody = OntologySuggestionBatchApplyRequest
    export type ApplyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPostMutationError = HTTPValidationError

    /**
 * @summary Atomically apply ontology suggestions from one generation run
 */
export const useApplyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost>>, TError,{workspaceId: number;runId: number;data: OntologySuggestionBatchApplyRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPost>>,
        TError,
        {workspaceId: number;runId: number;data: OntologySuggestionBatchApplyRequest},
        TContext
      > => {

      const mutationOptions = getApplyOntologyGenerationSuggestionsBatchApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationRunsRunIdSuggestionsApplyPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Apply a pending suggestion to ontology draft rows after steward review.
 * @summary Apply an ontology suggestion to the draft
 */
export const applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost = (
    workspaceId: number,
    suggestionId: number,
    applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody: ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OntologySuggestionResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/suggestions/${suggestionId}/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody, signal
    },
      );
    }
  


export const getApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost>>, TError,{workspaceId: number;suggestionId: number;data: ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost>>, TError,{workspaceId: number;suggestionId: number;data: ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody}, TContext> => {

const mutationKey = ['applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost>>, {workspaceId: number;suggestionId: number;data: ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody}> = (props) => {
          const {workspaceId,suggestionId,data} = props ?? {};

          return  applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost(workspaceId,suggestionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostMutationResult = NonNullable<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost>>>
    export type ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostMutationBody = ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody
    export type ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostMutationError = HTTPValidationError

    /**
 * @summary Apply an ontology suggestion to the draft
 */
export const useApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost>>, TError,{workspaceId: number;suggestionId: number;data: ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof applyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPost>>,
        TError,
        {workspaceId: number;suggestionId: number;data: ApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostBody},
        TContext
      > => {

      const mutationOptions = getApplyOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdApplyPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reject a pending ontology suggestion after steward review.
 * @summary Reject an ontology suggestion
 */
export const rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost = (
    workspaceId: number,
    suggestionId: number,
    rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody: RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OntologySuggestionResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/ontology-generation/suggestions/${suggestionId}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody, signal
    },
      );
    }
  


export const getRejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost>>, TError,{workspaceId: number;suggestionId: number;data: RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost>>, TError,{workspaceId: number;suggestionId: number;data: RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody}, TContext> => {

const mutationKey = ['rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost>>, {workspaceId: number;suggestionId: number;data: RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody}> = (props) => {
          const {workspaceId,suggestionId,data} = props ?? {};

          return  rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost(workspaceId,suggestionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostMutationResult = NonNullable<Awaited<ReturnType<typeof rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost>>>
    export type RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostMutationBody = RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody
    export type RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostMutationError = HTTPValidationError

    /**
 * @summary Reject an ontology suggestion
 */
export const useRejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost>>, TError,{workspaceId: number;suggestionId: number;data: RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPost>>,
        TError,
        {workspaceId: number;suggestionId: number;data: RejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostBody},
        TContext
      > => {

      const mutationOptions = getRejectOntologyGenerationSuggestionApiV1WorkspacesWorkspaceIdSemanticContextOntologyGenerationSuggestionsSuggestionIdRejectPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Compile the current workspace state into a candidate Runtime Context Pack.
 * @summary Compile workspace Runtime Context Pack
 */
export const compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextCompileResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/runtime-packs/compile`, method: 'POST',
        signal
    },
      );
    }
  


export const getCompileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost>>, TError,{workspaceId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost>>, TError,{workspaceId: number}, TContext> => {

const mutationKey = ['compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost>>, {workspaceId: number}> = (props) => {
          const {workspaceId} = props ?? {};

          return  compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost(workspaceId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePostMutationResult = NonNullable<Awaited<ReturnType<typeof compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost>>>
    
    export type CompileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePostMutationError = HTTPValidationError

    /**
 * @summary Compile workspace Runtime Context Pack
 */
export const useCompileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost>>, TError,{workspaceId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof compileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePost>>,
        TError,
        {workspaceId: number},
        TContext
      > => {

      const mutationOptions = getCompileRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksCompilePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List candidate, active, superseded, and failed packs for this workspace.
 * @summary List workspace Runtime Context Packs
 */
export const listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet = (
    workspaceId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextRuntimePackListResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/runtime-packs`, method: 'GET', signal
    },
      );
    }
  



export const getListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGetQueryKey = (workspaceId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/runtime-packs`
    ] as const;
    }

    
export const getListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGetQueryOptions = <TData = Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError = HTTPValidationError>(workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGetQueryKey(workspaceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>> = ({ signal }) => listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet(workspaceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGetQueryResult = NonNullable<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>>
export type ListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGetQueryError = HTTPValidationError


export function useListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet<TData = Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>,
          TError,
          Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet<TData = Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>,
          TError,
          Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet<TData = Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List workspace Runtime Context Packs
 */

export function useListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet<TData = Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError = HTTPValidationError>(
 workspaceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListRuntimeContextPacksApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksGetQueryOptions(workspaceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a single Runtime Context Pack manifest and lifecycle metadata.
 * @summary Get workspace Runtime Context Pack detail
 */
export const getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet = (
    workspaceId: number,
    packId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextRuntimePackDetail>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/runtime-packs/${packId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGetQueryKey = (workspaceId?: number,
    packId?: number,) => {
    return [
    `/api/v1/workspaces/${workspaceId}/semantic-context/runtime-packs/${packId}`
    ] as const;
    }

    
export const getGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError = HTTPValidationError>(workspaceId: number,
    packId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGetQueryKey(workspaceId,packId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>> = ({ signal }) => getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet(workspaceId,packId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(workspaceId && packId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>>
export type GetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGetQueryError = HTTPValidationError


export function useGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet<TData = Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    packId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>,
          TError,
          Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet<TData = Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    packId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>,
          TError,
          Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet<TData = Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    packId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get workspace Runtime Context Pack detail
 */

export function useGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet<TData = Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError = HTTPValidationError>(
 workspaceId: number,
    packId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdGetQueryOptions(workspaceId,packId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Promote a candidate pack and supersede any prior active pack.
 * @summary Activate workspace Runtime Context Pack
 */
export const activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost = (
    workspaceId: number,
    packId: number,
    activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody: ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SemanticContextCompileResponse>(
      {url: `/api/v1/workspaces/${workspaceId}/semantic-context/runtime-packs/${packId}/activate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody, signal
    },
      );
    }
  


export const getActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost>>, TError,{workspaceId: number;packId: number;data: ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost>>, TError,{workspaceId: number;packId: number;data: ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody}, TContext> => {

const mutationKey = ['activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost>>, {workspaceId: number;packId: number;data: ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody}> = (props) => {
          const {workspaceId,packId,data} = props ?? {};

          return  activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost(workspaceId,packId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostMutationResult = NonNullable<Awaited<ReturnType<typeof activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost>>>
    export type ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostMutationBody = ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody
    export type ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostMutationError = HTTPValidationError

    /**
 * @summary Activate workspace Runtime Context Pack
 */
export const useActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost>>, TError,{workspaceId: number;packId: number;data: ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePost>>,
        TError,
        {workspaceId: number;packId: number;data: ActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostBody},
        TContext
      > => {

      const mutationOptions = getActivateRuntimeContextPackApiV1WorkspacesWorkspaceIdSemanticContextRuntimePacksPackIdActivatePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
